import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModuleLargeStatement = ({
    eyebrowTitle,
    title,
    parent,
}) => {
    if (!title) { return null; }

    return (
        <div className={`${(parent === 'Home' || parent === 'Listing') ? 'py-40 md:py-50' : parent === 'Detail' ? 'py-20 md:py-30' : 'py-40 md:py-60'} bg-white relative`}>
            <div className='layout-container'>

                <div className='bg-white relative w-full flex flex-col'>
                    {eyebrowTitle && (
                        <p className='text-orange type-style-7 mb-7 sm:mb-20 md:mb-12 px-10 sm:px-5 md:px-10'>
                            {eyebrowTitle}
                        </p>
                    )}
                    <p className='type-style-1 px-10 sm:px-5 md:px-10 w-full sm:w-9/12'>
                        {title}
                    </p>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

ModuleLargeStatement.propTypes = {
    eyebrowTitle: PropTypes.string,
    title: PropTypes.string,
    parent: PropTypes.string,
};

export default ModuleLargeStatement;
